import type { MediaFileType } from '@coorum-research/shared-common/types'
import type { CSSProperties } from 'react'
import { VideoPlayer } from './VideoPlayer'

type Props = {
  mediaFileType: MediaFileType | undefined
  videoUrl?: string
  videoThumbnailUrl?: string
  imageUrl?: string
  className?: string
  style?: CSSProperties
  alt?: string
}

/**
 * video or image media item component
 * if mediaFileType is undefined, it will render an image
 */
export function MediaItem({
  videoUrl,
  videoThumbnailUrl,
  imageUrl,
  mediaFileType,
  className,
  style,
  alt,
}: Props) {
  if (mediaFileType === 'video' && videoUrl) {
    return (
      <VideoPlayer
        className={className}
        style={style}
        src={videoUrl}
        poster={videoThumbnailUrl}
      />
    )
  }

  if (imageUrl) {
    return (
      <img
        className={className}
        style={style}
        src={imageUrl}
        alt={alt}
      />
    )
  }

  return null
}
